export const TENANTS = {
  ADELPHI: 'adelphi',
  BORDERS: 'borders'
};
